import React, { useEffect } from 'react';
import './cpapp.css';

const Cpapp = ({ ciclo, asociacion }) => {
    useEffect(() => {
       window.scrollTo(0, 0);
    },
     []);

    const click1 = ( procedimiento ) => {
        var aux = document.getElementById( procedimiento ).style;
            aux.display = aux.display == 'block' ? 'none': "block";
    }

    return (    
        <div className='container'>
            <div className='row'>
                <div className='rubros_titulo'>
                    <h2>Concurso Público APP {ciclo}</h2>
                </div>               
                <div>                  
                    { asociacion.map((item, index)=>(
                        <>
                            <div className='convocatoria'>
                                <a href="#" onClick={(e) => {
                                    e.preventDefault();
                                    click1(item.numInvitacion);
                                }}>
                                    <div className="numconvocatoria">
                                        <h4 className="tituloConvoca">{item.numInvitacion}</h4>
                                    </div>
                                </a>
                                <div className="licitacion" id={item.numInvitacion} style={{display:'none'}}>
                                        { item.procedimiento.map((item1, index1)=>(
                                            <div>
                                                <h5 className="numlicitacion">{item1.numProc}</h5>
                                                <h6 className="vigencia">{item1.vigenciaProc}</h6>
                                                <div className="contenido">
                                                    <div className="descripcion">
                                                        <p className="nombrelicita">{item1.descripcionProc}</p>
                                                    </div>
                                                    <div className="anexos">
                                                        <p>Anexos</p>
                                                        <a className="actas" href={item1.urlAnexosProc}><i class="fas fa-download icodescarga"></i></a>
                                                    </div>                                                    
                                                    <div className="resultados">
                                                        <p className="encabezado">Resultados</p>
                                                        { item1.resultadosProc.map((item2, index2) => ( 
                                                            <>
                                                                <div><a href={ item2.urlResultado } target='_blank' >{ item2.resultado}</a></div>
                                                        </> )) }
                                                    </div>
                                                </div>
                                                <hr class="separador"></hr>
                                            </div>
                                        )
                                        ) }
                                              
                                    </div>       
                                </div>
                            </>
                        ) )
                    }
                </div>     
            </div>
        </div>
    )
}

export default Cpapp